import { jsx as _jsx } from "react/jsx-runtime";
import { buttonBase, colors } from "./theme.js";
/**
 * Generic segmented tab control (a row of mutually-exclusive pill buttons).
 * Single source of truth for the Sessions/Rules toggles that were each
 * hand-rolling the same bordered inline-flex switch.
 */
export function SegmentedTabs({ tabs, value, onChange, ariaLabel, style, }) {
    return (_jsx("div", { role: "tablist", "aria-label": ariaLabel, style: {
            display: "inline-flex",
            border: `1px solid ${colors.border}`,
            borderRadius: 8,
            overflow: "hidden",
            ...style,
        }, children: tabs.map((tab) => {
            const selected = tab.key === value;
            return (_jsx("button", { type: "button", role: "tab", "aria-selected": selected, onClick: () => onChange(tab.key), style: {
                    ...buttonBase,
                    borderRadius: 0,
                    background: selected ? colors.primary : colors.surface,
                    color: selected ? colors.surface : colors.textSecondary,
                }, children: tab.label }, tab.key));
        }) }));
}
